import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';
import { UCCSearchCategory } from './types';

type URLParams = {
  rn?: string;
  text?: string;
  uccNumber?: string;
  searchOptionType?: string;
  searchOptionSubOption?: string;
  searchCategory?: string;
};

export const useSearchPageQueryParams = () => {
  const [params, setParams] = useSearchParams();

  const updateURL = useCallback(
    (overrides: URLParams) => {
      setParams({ ...overrides }, { replace: true });
    },
    [setParams]
  );

  const getUrl = useCallback(
    (page: string, paramOverrides: Record<string, string | undefined | null>) => {
      const redirectParameters = new URLSearchParams(params);
      Object.entries(paramOverrides).forEach(([key, value]) => {
        if (value === null) {
          redirectParameters.delete(key);
        } else if (value) {
          redirectParameters.set(key, value);
        }
      });

      return `${page}?${redirectParameters.toString()}`;
    },
    [params]
  );

  return {
    getUrl,
    updateURL,
    rn: params.get('rn') ?? undefined,
    text: params.get('text') ?? undefined,
    uccNumber: params.get('uccNumber') ?? undefined,
    searchOptionType: params.get('searchOptionType') ?? undefined,
    searchOptionSubOption: params.get('searchOptionSubOption') ?? undefined,
    searchCategory: params.get('searchCategory') ?? UCCSearchCategory.Exact,
    pageNumber: params.get('page') ?? undefined,
  };
};
